
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AppContainer from '@/components/AppContainer.vue'
import AppButton from '@/components/AppButton.vue'
import AppLoading from '@/components/AppLoading.vue'

@Component({
    components: {
        AppButton,
        AppContainer,
        AppLoading,
        FontAwesomeIcon,
    },
})
export default class AppEditableHeader extends Vue {
    @Prop() public title?: string
    @Prop() public actionTitle?: string
    @Prop() public buttonsDisabled?: boolean
    @Prop({ default: false }) public loading?: boolean

    get actionTitleNotNull() {
        return this.actionTitle ? this.actionTitle : 'Salvar'
    }

    @Emit('close')
    public onClose(e: Event) {
        return e
    }

    @Emit('save')
    public onSave(e: Event) {
        return e
    }
}
